import React, { useContext } from 'react';
import { ConfigurationsMicroFrontend } from '@allie/mfe';
import { env } from '@env';
import { AppContext, AuthContext, UtilsContext } from '../../context';
import { isMobile, isTablet } from '../../helpers/utils';
import { CommonPageProps } from '../../App.types';
import { useAppTranslations } from '../../hooks';

export const ConfigurationsPage: React.FC<CommonPageProps> = ({ basePath, openLogin }) => {
  const { permissions, loggedUser, tryGuestLogin } = useContext(AuthContext);
  const { lang } = useContext(AppContext);

  const { tracker, company } = useContext(UtilsContext);
  const { LOADING_MESSAGES } = useAppTranslations();
  if (!company) return null;
  return (
    <ConfigurationsMicroFrontend
      entryPointUrl={env.REACT_APP_CONFIGURATIONS_ENTRYPOINT || ''}
      className="page-content"
      basePath={basePath}
      permissions={permissions}
      tryGuestLogin={tryGuestLogin}
      loggedUser={loggedUser}
      loadingMessage={LOADING_MESSAGES.CONFIGURATIONS}
      openLogin={openLogin}
      isMobile={isMobile}
      isTablet={isTablet}
      tracker={tracker}
      lang={lang}
      company={company}
    />
  );
};
